import { useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';
import { useIsMount } from '../../../utils/hooks';

export const useItems = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const { openModal } = useModals();
    const formId = 'laundry-items-create-modal';
    const navigate = useNavigate();
    const location = useLocation();
    const isMount = useIsMount();
    const [searchParams, setSearchParams] = useSearchParams();

    const [activeTab, setActiveTab] = useState<string>('in_use');

    useEffect(() => {
        if (isMount) {
            return;
        } else {
            setSearchParams((prev) => {
                const params = new URLSearchParams();
                params.set('tab', activeTab);
                return params;
            });
        }
    }, [activeTab]);

    return {
        dispatch,
        currentAccount,
        openModal,
        activeTab,
        setActiveTab,
        formId,
        navigate,
        location
    };
};
